export default __webpack_public_path__ + "static/12-97ffbbcdc72811b34f554546c0808bd8.jpg";